<template>
  <div class="Villa-container">

    <SectionTop :id="4" />

    <div class="villa-wrapper">

      <div class="villa-block">
        <div class="villa-bg"></div>
        <div class="villa-project-media-container">
          <div class="villa-project-text-container">
            <div class="villa-project-text">
              <p>
                2022年5月に作成した伊豆大島別荘プロジェクトの計画書。<br>
                何かをつくりたい欲に駆られたときに生まれるものがご覧になれます。
              </p>
            </div>
            <ViewMore :id="5" customClass="view-more-wrapper-slide" />
          </div>
          <div class="villa-slide-container">
            <div v-rellax data-rellax-speed="0.3" data-rellax-percentage="3.5" class="villa-slide-column">
              <img class="villa-slide-img" src="@/assets/img/home/slide_sample_img8.png" alt="伊豆大島別荘計画スライド 1">
              <img class="villa-slide-img" src="@/assets/img/home/slide_sample_img5.png" alt="伊豆大島別荘計画スライド 2">
            </div>
            <div v-rellax data-rellax-speed="-0.3" data-rellax-percentage="0.0" class="villa-slide-column">
              <img class="villa-slide-img" src="@/assets/img/home/slide_sample_img7.png" alt="伊豆大島別荘計画スライド 3">
              <img class="villa-slide-img" src="@/assets/img/home/slide_sample_img6.png" alt="伊豆大島別荘計画スライド 4">
            </div>
          </div>
        </div>
      </div>

      <div class="villa-block">
        <div class="villa-bg villa-bg-1"></div>
        <div class="villa-project-media-container villa-project-media-container-1">
          <div class="villa-video-container">
            <div v-rellax data-rellax-speed="0.3" data-rellax-percentage="0.5" class="villa-video-column">
              <img class="villa-video-img" src="@/assets/img/home/thumbnail_video1.png" @click="openModal('video1.mp4')"
                alt="伊豆大島別荘計画動画 1">
              <img class="villa-video-img" src="@/assets/img/home/thumbnail_video2.png" @click="openModal('video2.mp4')"
                alt="伊豆大島別荘計画動画 2">
              <img class="villa-video-img" src="@/assets/img/home/thumbnail_video5.png" @click="openModal('video5.mp4')"
                alt="伊豆大島別荘計画動画 3">
            </div>
            <div v-rellax data-rellax-speed="-0.3" data-rellax-percentage="-4" class="villa-video-column">
              <img class="villa-video-img" src="@/assets/img/home/thumbnail_video3.png" @click="openModal('video3.mp4')"
                alt="伊豆大島別荘計画動画 4">
              <img class="villa-video-img" src="@/assets/img/home/thumbnail_video4.png" @click="openModal('video4.mp4')"
                alt="伊豆大島別荘計画動画 5">
            </div>
          </div>
          <div class="villa-project-text villa-project-text-1">
            <p>
              2022年7月に作成したアニメーション動画。<br>
              AdobeのAfterEffectsで作成。<br>
              こちらも何かを作りたい欲のはけ口となったもの。供養。<br>
              AEに触れるのは初めてで、はじめのうちは線の長さを伸縮させることだけにも苦心していた。最終的にどうなったかご覧ください。
              <br><br>
              &lt;--&emsp;click to play
            </p>
          </div>
        </div>
        <!-- modal -->
        <transition name="modal-fade">
          <div class="modal" v-if="showModal" @click="closeModal">
            <video :src="videoFileName" controls autoplay muted playsinline @click.stop></video>
          </div>
        </transition>
      </div>

      <div class="villa-block">
        <div class="villa-bg villa-bg-2"></div>
        <div class="villa-project-text villa-project-text-2">
          <p>
            別荘用に構築していた当初のサイト。<br>
            構築の途中でしたが、アクセスできます。<br><br>
            ↓&emsp;click to access
          </p>
        </div>
        <div v-scroll-animation class="villa-site-container scroll-animation">
          <a :href="s3UrlVilla" target="_blank" rel="noopener noreferrer">
            <img class="villa-site-img" src="@/assets/img/home/villa_homepage.png" alt="伊豆大島別荘計画サイト">
          </a>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import SectionTop from '@/features/home/components/SectionTop.vue';
import ViewMore from '@/features/home/components/ViewMore.vue';

export default {
  name: "Videos",
  components: {
    SectionTop,
    ViewMore,
  },
  data() {
    return {
      showModal: false,
      videoFileName: "",
      s3UrlVilla: process.env.VUE_APP_S3_VILLA,
    };
  },
  methods: {
    openModal(videoFileName) {
      this.videoFileName = `https://kokozero-static-assets.s3.ap-northeast-1.amazonaws.com/video/home/${videoFileName}`;
      this.showModal = true;
    },
    closeModal() {
      this.videoFileName = "";
      this.showModal = false;
    },
  },
};
</script>

<style scoped>
.Villa-container {
  position: relative;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 0px;
  margin-bottom: 150px;
}

.villa-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.villa-block {
  position: relative;
  height: auto;
  padding-top: 60px;
  margin-bottom: 50px;
}


/*********************/
/******* スライド *******/
/*********************/

.villa-bg {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: hsla(178, 0%, 100%, 1);
  background-image:
    radial-gradient(at 57% 62%, hsla(181, 100%, 50%, 0.1) 0px, transparent 50%),
    radial-gradient(at 78% 37%, hsla(157, 100%, 50%, 0.31) 0px, transparent 50%),
    radial-gradient(at 4% 93%, hsla(178, 100%, 50%, 0.19) 0px, transparent 50%),
    radial-gradient(at 85% 86%, hsla(180, 100%, 50%, 0.08) 0px, transparent 50%);
  opacity: 0.1;
  z-index: -1;
}

.villa-project-media-container {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

.villa-project-text-container {
  position: relative;
  top: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: 0px;
}

.villa-project-text {
  width: 100%;
  height: auto;
  font-family: sans-serif;
  font-size: 13px;
  line-height: 2rem;
}

.view-more-wrapper-slide {
  transform: translateX(-10%);
}

.villa-slide-container {
  width: 50%;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.villa-slide-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 45px;
}

.villa-slide-img {
  width: 100%;
  height: auto;
  filter: drop-shadow(5px 5px 5px #848e8d7e);
}

.villa-slide-column:nth-child(1) {
  transform: translateY(20%);
}



/*********************/
/******* ビデオ *******/
/*********************/

.villa-bg-1 {
  position: absolute;
  left: 0;
  background-color: hsla(178, 0%, 100%, 1);
  background-image:
    radial-gradient(at 20% 24%, hsla(174, 100%, 50%, 0.1) 0px, transparent 50%),
    radial-gradient(at 17% 64%, hsla(183, 100%, 50%, 0.2) 0px, transparent 50%),
    radial-gradient(at 63% 43%, hsla(178, 100%, 50%, 0.19) 0px, transparent 50%),
    radial-gradient(at 85% 83%, hsla(180, 100%, 50%, 0.08) 0px, transparent 50%);
}

.villa-video-container {
  width: 70%;
  display: flex;
  flex-wrap: wrap;
  column-gap: 10px;
}

.villa-video-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 45px;
}

.villa-video-img {
  width: 85%;
  height: auto;
  box-shadow:
    1.6px 1.8px 2.7px rgba(0, 0, 0, 0.08),
    4.2px 4.4px 6.9px rgba(0, 0, 0, 0.013),
    8.5px 9px 14.2px rgba(0, 0, 0, 0.17),
    17.5px 18.6px 29.2px rgba(0, 0, 0, 0.11),
    48px 51px 80px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: transform 0.3s;
}

.villa-video-img:hover {
  transform: scale(1.01);
}

.villa-video-column:nth-child(2) {
  transform: translateY(20%);
}

.villa-project-text-1 {
  position: relative;
  margin-top: 180px;
  left: 50px;
  width: 60%;
}

/* モーダルウィンドウのスタイル */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

/* フェードイン/フェードアウトアニメーションの定義 */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modal video {
  z-index: 9999;
  width: 80%;
  height: auto;
}


/*********************/
/******* サイト *******/
/*********************/

.villa-bg-2 {
  position: absolute;
  background-color: hsla(178, 0%, 100%, 1);
  background-image:
    radial-gradient(at 43% 77%, hsla(178, 100%, 50%, 0.1) 0px, transparent 50%),
    radial-gradient(at 51% 43%, hsla(175, 100%, 49%, 0.2) 0px, transparent 50%),
    radial-gradient(at 81% 36%, hsla(178, 100%, 50%, 0.16) 0px, transparent 50%),
    radial-gradient(at 85% 83%, hsla(180, 100%, 50%, 0.08) 0px, transparent 50%);
  opacity: 0.2;
}

.villa-project-text-2 {
  position: relative;
  left: 50%;
  transform: translate(-50%, 0%);
  width: 500px;
  text-align: center;
}

.villa-site-container {
  position: relative;
  top: 30px;
  left: 50%;
  transform: translate(-50%, 0%);
  width: 50%;
}

.villa-site-img {
  width: 100%;
  height: auto;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px;
  transition: transform 0.5s;
}

.villa-site-img:hover {
  transform: scale(1.01);
}

/* タブレット、スマートフォン向けのスタイル */
@media screen and (max-width: 1024px) {

  .villa-block {
    padding-top: 30px;
    margin-bottom: 30px;
  }

  .villa-project-text {
    position: relative;
    left: 8%;
    width: 70%;
    font-size: 11px;
    line-height: 1.5rem;
  }

  .view-more-wrapper-slide {
    transform: translate(-5%, -40%);
  }

  .villa-project-text-1 {
    position: relative;
    margin-top: 100px;
    width: 50%;
  }

  .villa-project-text-2 {
    left: 50%;
    transform: translate(-50%, 0%);
    margin-top: 110px;
  }

}

@media screen and (max-width: 570px) {

  .Villa-container {
    margin-bottom: 90px;
  }

  .villa-wrapper {
    row-gap: 50px;
  }

  .villa-project-media-container {
    flex-direction: column-reverse;
  }

  .villa-slide-container {
    align-self: center;
    width: 80%;
    gap: 10px;
    transform: translateY(-30%);
  }

  .villa-slide-column {
    gap: 25px;
  }

  .villa-slide-column:nth-child(2) {
    transform: translateY(50%) !important;
  }

  .villa-project-text {
    width: 80%;
    font-size: 11px;
    line-height: 1.5rem;
    margin-top: 10px;
  }

  .view-more-wrapper-slide {
    margin-top: 20px;
  }


  .villa-project-media-container-1 {
    flex-direction: column;
  }

  .villa-video-container {
    width: 80%;
    align-self: center;
    transform: translateY(-20%);
  }

  .villa-video-column {
    gap: 20px;
  }

  .villa-video-column:nth-child(2) {
    transform: translateY(50%) !important;
  }

  .villa-project-text-1 {
    margin-top: 30px;
    width: 80%;
  }

  .modal video {
    width: 90%;
  }

  .villa-site-container {
    top: 40px;
    width: 90%;
  }
}
</style>